module.exports = __webpack_public_path__ + "static/alec2x-05fb06713b06cbf63c93ae628a3ce396.png";